export enum PortalLoginResult {
  Success = 0, // correct credentials, no further info needed
  InvalidCredentials = 1, // incorrect credentials
  AcknowledgementNeeded = 2, // correct credentials, but need to acknowledge terms
  AddCustomerToApplication = 3, // when portal link created to add a co-applicant.
  ViewCuratedVehicles = 4, // when portal link created to view curated vehicles.
}